import { render, staticRenderFns } from "./CrearanamnesisEditarAtencion.vue?vue&type=template&id=3fd59a6f"
import script from "./CrearanamnesisEditarAtencion.vue?vue&type=script&lang=js"
export * from "./CrearanamnesisEditarAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports